import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SCMContractApi, { SCMContract, SCMContractListParams } from "@api/scmAPI";
import { ListResponseType } from "src/types";

interface IState {
  isFetching: boolean;
}

const initialState: IState = {
  isFetching: false,
};

export const fetchContractList = createAsyncThunk<ListResponseType<SCMContract>, SCMContractListParams>(
  "SCM/fetchContractList",
  async (params, thunkApi) => {
    try {
      const response = await SCMContractApi.fetchContractList(params);
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

const SCMSlice = createSlice({
  name: "scm",
  initialState,
  reducers: {
    resetSCMSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchContractList.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(fetchContractList.fulfilled, (state, action) => {
      state.isFetching = false;
    });
    builder.addCase(fetchContractList.rejected, (state) => {
      state.isFetching = false;
    });
  },
});

export const { resetSCMSlice } = SCMSlice.actions;
export default SCMSlice.reducer;
